const allowDebug = process.env.DEBUG || process.env.NODE_ENV === 'development';
function debug(...args) {
	if (allowDebug) {
		console.log('%c🟣_EG DEBUG:', 'color: purple', ...args);
	}
}

export default debug;
